export const getMonitoringLogByMediaUrl =
  "/api/v3/monitor/log/campaign/:campaignId/media/:mediaId";
export const downloadMonitorPdfUrl =
  "/api/v3/campaign/:campaignId/media/:mediaId/monitorlog/export/pdf";
